import { useState, useEffect } from "react";
import { supabase } from "../constants";
import { candidatePhase } from "../shared";

// Avisos del cliente (03/11): lo que antes era «Lo que toca» de la Home.
// FUENTE ÚNICA: la campanita del menú cuenta estos avisos y la pantalla
// Notificaciones (NotificationsView.jsx) los pinta. Aquí solo datos; los
// textos van en la pantalla. De más urgente a menos: decisiones pendientes,
// mapping por aprobar, entrevistas sin evaluar y el Culture statement sin hacer.
export const useClientTodos = ({ openPositionsList = [], candidateStatuses = {}, selectedClientId = null, hasCultureDoc = false }) => {
  const [mappingCount, setMappingCount] = useState({}); // empresas del mapping por posición

  // Mapping por aprobar: solo cuenta si la posición tiene empresas propuestas
  const unapprovedIds = openPositionsList.filter(p => !p.mappingApprovedAt).map(p => p.id).join(",");
  useEffect(() => {
    const ids = unapprovedIds ? unapprovedIds.split(",") : [];
    if (!ids.length) { setMappingCount({}); return; }
    supabase.from("mapping_companies").select("position_id").in("position_id", ids).then(({ data }) => {
      const out = {};
      (data || []).forEach(r => { out[r.position_id] = (out[r.position_id] || 0) + 1; });
      setMappingCount(out);
    });
  }, [unapprovedIds]);

  const items = [];
  openPositionsList.forEach(p => {
    const cands = p.candidates || [];
    const pending = cands.filter(c => candidatePhase(c, candidateStatuses) === "pending");
    if (pending.length) items.push({ key: `pend-${p.id}`, kind: "pending", p, cands: pending });
    if (!p.mappingApprovedAt && mappingCount[p.id]) items.push({ key: `map-${p.id}`, kind: "mapping", p });
    const noEval = cands.filter(c => candidatePhase(c, candidateStatuses) === "interview" && !(c.evalManagers || []).length);
    if (noEval.length) items.push({ key: `eval-${p.id}`, kind: "eval", p, cands: noEval });
  });
  if (selectedClientId && !hasCultureDoc) items.push({ key: "culture", kind: "culture" });
  return items;
};
